import { updatePasswordService } from 'services/user/updatePassword';

export const updatePassword = async (
  code,
  password,
  confirmPassword,
  secretID
) => {
  if (password !== confirmPassword) {
    return {
      message: 'Password Doesn’t Match',
      status: false,
      type: 'confirmPassword',
    };
  }

  const { status } = await updatePasswordService({
    password,
    secretCode: code,
    secretID,
  });

  if (status === 400) {
    return {
      message: 'Verification Code Expired',
      status: false,
      type: 'codeExpired',
    };
  } else if (status === 200) {
    return {
      status: true,
    };
  } else if (status === 500) {
    return {
      status: false,
      message: 'Code miss match! Check the code again.',
      type: 'code',
    };
  }

  return {
    status: false,
    message: 'Some error occured. Please try again after sometime.',
    type: '404',
  };
};
